import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject, model } from '@angular/core';

import { NotificationStateService } from '@shared/services/notifications';
import { DashboardNotification } from '../dashboard-notification';
import { MatMenuItem } from '@angular/material/menu';
import { RouterLink } from '@angular/router';

import { MatIcon } from '@angular/material/icon';
import { ConvertDateToTimePipe } from '../../../../../../shared/pipes/convert-date-to-time.pipe';

@Component({
  selector: 'app-primary-notification',
  templateUrl: './primary-notification.component.html',
  styleUrl: './primary-notification.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [MatMenuItem, RouterLink, MatIcon, ConvertDateToTimePipe],
})
export class PrimaryNotificationComponent {
  private notificationStateService = inject(NotificationStateService);
  readonly notification = model<DashboardNotification>();

  public async notificationClicked(): Promise<void> {
    const notification = this.notification();
    if (notification.readAtTime == null) {
      await this.notificationStateService.markChatRequestNotificationsAsRead(notification.id);
    }
  }
}
